import { WithDrawFromLeagueData, withDrawPlayerFromLeague } from '@/services/actions/league/withdrawPlayer';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

export const useWithdrawPlayerFromLeagueMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (data: WithDrawFromLeagueData) => withDrawPlayerFromLeague(data),
		onSuccess: (_data) => {
			queryClient.invalidateQueries({ queryKey: ['TEAM_LEAGUE_DETAILS'] });
			toast.success('You’ve successfully submitted your withdrawal request.');
		},
		onError: () => {
			toast.error('We couldn’t submit your withdrawal. Please try again later.');
		}
	});
};
